/**
 * Minimal SSE frame parser (event + data lines, blank-line delimited).
 * Shared by live credit-stream and Socket-API rate stream.
 */

export function parseSseChunk(
  buffer: string,
  onEvent: (name: string, data: string) => void,
): string {
  const parts = buffer.split('\n\n')
  const rest = parts.pop() ?? ''
  for (const block of parts) {
    if (!block.trim() || block.startsWith(':')) continue
    let eventName = 'message'
    const dataLines: string[] = []
    for (const line of block.split('\n')) {
      if (line.startsWith('event:')) eventName = line.slice(6).trim()
      else if (line.startsWith('data:')) dataLines.push(line.slice(5).trim())
    }
    if (dataLines.length) onEvent(eventName, dataLines.join('\n'))
  }
  return rest
}
